import InvitePolitely from "./component/invitePolitely";
import withHeaderFooter from "@/app/csr-src/hocs/with-header-footer";

const InvitePolitelyPage = withHeaderFooter(() => {
  return <InvitePolitely />;
});

export default InvitePolitelyPage;
